<ui-form-text
  (change)="onPasswordBlur()"
  (input)="onPasswordInput()"
  [formControl]="controlPassword"
  [data]="statePassword"
></ui-form-text>
<span (click)="switchIsMasked()" [class.masked]="isMasked" class="icon">
  <ui-icon faName="eye" faStyle="light"></ui-icon>
  <ui-icon faName="eye-slash" faStyle="light"></ui-icon>
</span>
<ui-form-text
  (input)="onRepeatInput()"
  [formControl]="controlRepeat"
  [data]="stateRepeat"
></ui-form-text>
